<template>
  <div class="control is-expanded" :class="[size]">
    <d-dropdown
      ref="dropdown"
      :position="position"
      :disabled="disabled"
      trap-focus
      class="py-0"
    >
      <template #activator>
        <div>
          <d-input
            ref="input"
            autocomplete="off"
            v-model="computedValue"
            :placeholder="placeholder"
            :size="size"
            :rounded="rounded"
            :loading="loading"
            :disabled="disabled"
            :readonly="!editable"
            v-bind="$attrs"
            @change.native="$emit('change', $event)"
            @focus="$emit('focus', $event)"
            @blur="$emit('blur', $event)"
          />
        </div>
      </template>

      <d-dropdown-item :disabled="disabled" custom paddingless class="p-0">
        <chrome-picker v-model="computedColorValue" />
      </d-dropdown-item>
    </d-dropdown>
  </div>
</template>

<script>
import FormElementMixin from "@mixins/formElementMixin.js";
import DInput from "@components/DInput.vue";

import { ChromePicker } from "vue-color";
import 'vue-color/style.css';

export default {
  components: {
    ChromePicker,
    DInput,
  },

  mixins: [FormElementMixin],

  props: {
    modelValue: String,
    disabled: Boolean,
    editable: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
    position: {
      type: String,
      default: "left",
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },

    computedColorValue: {
      get() {
        return this.modelValue || "#000000";
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
